module.exports = __webpack_public_path__ + "static/media/gery-tan-95.ee67743a.jpg";